// UPDATE: frontend/src/config/api.js

import axios from 'axios';
import { clearSessionStorageKeys } from '../utils/userScopedStorage';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// Create axios instance with company context
// Timeout increased to 10 minutes to accommodate long-running operations
// like AI categorization with Claude API and OAuth flows with multiple API calls
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 600000, // 10 minutes - supports AI operations and OAuth flows
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle company context and errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('company');
      clearSessionStorageKeys(); // the signed-out user's chat and selections (DT-1521)
      window.location.href = '/login';
    }
    
    if (error.response?.status === 403 && error.response?.data?.code === 'MFA_SETUP_REQUIRED') {
      // Admin account without 2-step verification (MFA_ENFORCE_FOR_ADMINS on): only the Profile page works.
      if (window.location.pathname !== '/profile') window.location.href = '/profile';
    } else if (error.response?.status === 403) {
      // Company access denied
      console.error('Company access denied:', error.response.data);
    }

    // DT-1279: the one-company-per-account refusal (409 ACCOUNT_OWNED_BY_OTHER_COMPANY) carries a sentence meant for the
    // user. Connector screens show err.message, which would otherwise be axios's "Request failed with status code 409".
    if (error.response?.data?.code === 'ACCOUNT_OWNED_BY_OTHER_COMPANY' && error.response.data.message) {
      error.message = error.response.data.message;
    }

    return Promise.reject(error);
  }
);

export default api;